import { initialState, types } from 'store/Bundles'

export const updateAnswer = (questionId, value) => {
  return { type: types.UPDATE_ANSWER, questionId, value }
}

export const updateFormData = data => {
  return { type: types.UPDATE_FORM_DATA, data }
}

export const setActiveQuestions = questions => {
  return { type: types.SET_ACTIVE_QUESTIONS, questions }
}

export const clearForm = () => {
  return { type: types.CLEAR_FORM }
}

export default (state = initialState, { type, ...payload }) => {
  switch (type) {
    case types.UPDATE_ANSWER:
      return {
        ...state,
        form: {
          ...state.form,
          answers: {
            ...state.form.answers,
            [payload.questionId]: payload.value,
          },
        },
      }
    case types.UPDATE_FORM_DATA:
      return {
        ...state,
        form: {
          ...state.form,
          ...payload.data,
          answers: {
            ...state.form.answers,
            ...payload.data.answers,
          },
        },
      }
    case types.SET_ACTIVE_QUESTIONS: {
      return {
        ...state,
        form: {
          ...state.form,
          activeQuestions: payload.questions,
        },
      }
    }
    case types.CLEAR_FORM:
      return {
        ...state,
        form: {
          ...initialState.form,
        },
      }
    default:
      return state
  }
}
